import { render, staticRenderFns } from "./OrbitInsufficientGasStep.vue?vue&type=template&id=f3d1e3a2&scoped=true"
import script from "./OrbitInsufficientGasStep.vue?vue&type=script&lang=ts"
export * from "./OrbitInsufficientGasStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitInsufficientGasStep.vue?vue&type=style&index=0&id=f3d1e3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d1e3a2",
  null
  
)

export default component.exports